export const generalPlaceholders = [
  { value: '%s', label: '%s' },
  { value: '@v', label: '@v' },
  { value: '%v', label: '%v' },
  { value: '%f', label: '%f' },
]

export const namedPlaceholders = [
  { value: '{{ }}', label: '{{ }}' },
  { value: '__ __', label: '__ __' },
  { value: '[[ ]]', label: '[[ ]]' },
  { value: '{ }', label: '{ }' },
]
